import { render } from "./DomesticBookingForm.vue?vue&type=template&id=19f1d120"
import script from "./DomesticBookingForm.vue?vue&type=script&lang=js"
export * from "./DomesticBookingForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/abdom-booking/abdom-booking/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__